/* Footer Beauty V2 — activo solo en Spray Fijador V2. */
(function () {
  'use strict';

  if (!document.querySelector('link[href*="shabima-spray-v2.css"]')) return;
  if (window.__shabimaSprayV2BeautyFooter) return;
  window.__shabimaSprayV2BeautyFooter = true;

  function mountBeautyFooter() {
    var existing = document.querySelector('.shabima-footer-full');
    var group = document.querySelector('.shopify-section-group-footer-group');

    if (existing) {
      if (group && !group.contains(existing)) group.remove();
      return;
    }
    if (!group || group.hasAttribute('data-shabima-beauty-footer-mounted')) return;

    var year = new Date().getFullYear();
    var html = `
      <footer class="shabima-footer-full" aria-label="Pie de página SHABIMA">
        <div class="shabima-wrap">
          <div class="shabima-footer-full__grid">
            <div class="shabima-footer-full__col shabima-footer-full__col--brand">
              <a href="/" class="shabima-footer-full__brand-link" aria-label="Inicio SHABIMA">
                <svg viewBox="0 0 120 120" width="48" height="48" aria-hidden="true" focusable="false" class="shabima-footer-full__logo">
                  <ellipse cx="57" cy="61" rx="43" ry="49" fill="none" stroke="#c5a58d" stroke-width="3"></ellipse>
                  <path d="M73 34c-10-9-34-5-34 11 0 21 39 12 38 36-1 18-28 21-40 10" fill="none" stroke="#f8f3ef" stroke-width="7.5" stroke-linecap="round"></path>
                  <circle cx="94" cy="24" r="9" fill="#c5a58d"></circle>
                  <circle cx="94" cy="24" r="4" fill="#342725"></circle>
                  <path d="M85 17c5-5 13-5 18 0" fill="none" stroke="#e4b9c2" stroke-width="3" stroke-linecap="round"></path>
                </svg>
                <span class="shabima-footer-full__brand-name">SHABIMA</span>
                <span class="shabima-footer-full__brand-sub">BEAUTY</span>
              </a>
              <p class="shabima-footer-full__tagline">Bienestar &amp; Belleza&nbsp;·&nbsp;Hecho para ti.</p>
            </div>
            <div class="shabima-footer-full__col">
              <p class="shabima-footer-full__col-title">Tienda</p>
              <nav aria-label="Políticas de la tienda"><ul class="shabima-footer-full__links">
                <li><a href="/policies/privacy-policy">Política de privacidad</a></li>
                <li><a href="/policies/refund-policy">Devoluciones y reembolsos</a></li>
                <li><a href="/policies/shipping-policy">Política de envíos</a></li>
                <li><a href="/policies/terms-of-service">Términos de servicio</a></li>
              </ul></nav>
            </div>
            <div class="shabima-footer-full__col">
              <p class="shabima-footer-full__col-title">Contacto</p>
              <ul class="shabima-footer-full__links">
                <li><a href="https://wa.me/573219275641" rel="nofollow noopener noreferrer" target="_blank"><svg class="shabima-footer-full__icon" viewBox="0 0 20 20" width="15" height="15" aria-hidden="true" fill="currentColor"><path d="M10 0C4.477 0 0 4.41 0 9.85c0 1.74.46 3.37 1.26 4.79L0 20l5.52-1.24A10.05 10.05 0 0010 19.7C15.523 19.7 20 15.29 20 9.85 20 4.41 15.523 0 10 0zm5.18 13.9c-.22.61-1.27 1.18-1.75 1.22-.45.04-.46.34-2.91-.65-2.72-1.1-4.38-3.8-4.51-3.97-.13-.17-1.08-1.43-1.08-2.73 0-1.3.69-1.94.93-2.2.24-.26.52-.33.7-.33.18 0 .35.002.5.01.16.008.38-.06.59.45.22.52.75 1.82.82 1.96.07.13.11.29.02.46-.09.17-.13.28-.26.43-.13.15-.27.33-.39.44-.13.12-.26.25-.11.5.15.24.67 1.1 1.44 1.78.99.88 1.83 1.15 2.08 1.28.25.13.4.11.55-.07.15-.18.63-.73.8-.98.17-.25.34-.21.57-.13.23.09 1.48.69 1.73.82.25.13.42.19.48.3.06.11.06.66-.16 1.27z"></path></svg>WhatsApp · +57 321 927 5641</a></li>
                <li><a href="mailto:contacto@shabima.com"><svg class="shabima-footer-full__icon" viewBox="0 0 20 20" width="15" height="15" aria-hidden="true" fill="currentColor"><path d="M18 4H2a2 2 0 00-2 2v8a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 2v.5l-8 5-8-5V6h16zM2 14V9l7.4 4.63a1 1 0 001.2 0L18 9v5H2z"></path></svg>contacto@shabima.com</a></li>
              </ul>
            </div>
            <div class="shabima-footer-full__col">
              <p class="shabima-footer-full__col-title">Pagos y envíos</p>
              <ul class="shabima-footer-full__trust">
                <li class="shabima-footer-full__trust-item"><span class="shabima-footer-full__trust-dot" aria-hidden="true"></span><span><strong>Pago al recibir</strong><br><small>Pagas cuando llega tu pedido</small></span></li>
                <li class="shabima-footer-full__trust-item"><span class="shabima-footer-full__trust-dot" aria-hidden="true"></span><span><strong>Pago anticipado</strong><br><small>Transfiere y elige tu opción</small></span></li>
                <li class="shabima-footer-full__trust-item"><span class="shabima-footer-full__trust-dot" aria-hidden="true"></span><span><strong>Envíos a Colombia</strong><br><small>Con número de seguimiento</small></span></li>
              </ul>
            </div>
          </div>
          <div class="shabima-footer-full__sep" role="separator" aria-hidden="true"></div>
          <div class="shabima-footer-full__bottom"><p class="shabima-footer-full__copy">&copy;&nbsp;${year}&nbsp;SHABIMA. Todos los derechos reservados.</p></div>
        </div>
      </footer>`;

    group.insertAdjacentHTML('beforeend', html);
    group.setAttribute('data-shabima-beauty-footer-mounted', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBeautyFooter, { once: true });
  } else {
    mountBeautyFooter();
  }
})();
